import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {PurlRoutingModule} from "./purl-routing.module";
import {PURLPageComponent} from "./components/purlpage/purlpage.component";
import {LandingPagesModule} from "fello-common";

@NgModule({
  declarations: [PURLPageComponent],
  imports: [CommonModule, PurlRoutingModule, LandingPagesModule]
})
export class PurlModule {}
